import React from 'react';

const Navbar = ({ logout }) => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container">
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img src="https://vet-mkononi.co.ke/wp-content/uploads/2024/04/cropped-logo-1.png" alt="Vet Mkononi Logo" width="150" className="d-inline-block me-2" />
          Vet Mkononi AI Assistant
        </a>
        <button className="btn btn-outline-danger" onClick={logout}>Logout</button>
      </div>
    </nav>
  );
};

export default Navbar;